export default "__VITE_ASSET__DuOucrks__"